<template lang="html">
  <v-btn color="green" icon @click="$emit('editClick', el)">
    <v-icon>edit</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'StandardEditBtn',
  props: ['el']
}
</script>

<style lang="css" scoped>
</style>
